import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAccessibility } from "../../../../hooks/useAccessibility";
import { DropdownPlanes } from "./DropdownPlanes";
import { HGResourcesButton } from "../../components/button-resources/hg-resources-button";
import { buildMakeMakeComercialUrlByEnv } from "../../../../util/host-utilities";

/**
 * Componente con las opciones del header sin login. (Agenda un demo, Planes, libros , comunidad, iniciar sesión, ajustes, notificaciones)
 * @param {object} textosInterfaz - objeto que contiene los textos de interfaz
 * @returns {JSX.Element} NavbarNav
 */
export const NavbarNav = ({ textosInterfaz }) => {

  const [openDropdown, setOpenDropdown] = useState(false);
  const location = useLocation();
  const planesRef = useRef();
  const collectionUrl = buildMakeMakeComercialUrlByEnv({ path: "/libros" });

  const accessibility = useAccessibility();

  /**Función que permite cerrar el dropdown dando click fuera de él*/
  useEffect(() => {
    let handler = (e) => {
      if (location.pathname !== '/institucional/formulario' && !planesRef.current.contains(e.target)) {
        setOpenDropdown(false)
      }
    }
    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler)
    }
  }, [])


  /*cierra el dropdown al hacer scroll al inicio de la página */
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY >= 1 && window.scrollY < 10) {
        setOpenDropdown(false)
      }
    });
  }, [accessibility.state.visible])

  return (
    <>
      <ul className="option-nav d-flex" role="list">
        {location.pathname !== '/institucional/formulario' &&
          <>
            <li className="ml-2">
              <a
                href={collectionUrl}
                className={`focusable-red ${location.pathname === '/libros' ? "btn-header-general  activeMode" : "btn-header-general "}`}
              >
                {textosInterfaz?.coleccion || 'Conoce la colección'}
              </a>
            </li>
            <li ref={planesRef} className="relative  ml-2">
              <button
                className={`focusable-red  btn-header-general`}
                onClick={() => {
                  setOpenDropdown(!openDropdown)
                }}
                aria-label={textosInterfaz?.button_plans_description}
              >
                {textosInterfaz?.quiero_make || 'Planes'}
              </button>

              <div className={`dropdownMenu ${openDropdown ? 'activeMode' : 'inactiveMode'} `}>
                <DropdownPlanes
                  setOpenDropdown={setOpenDropdown}
                  openDropdown={openDropdown}
                  textosInterfaz={textosInterfaz}
                />
              </div>

            </li>

            <li>
              <Link
                className={`
                    focusable-red
                    d-flex
                    justify-content-center
                    align-items-center
                    body-m
                    btn-header-general
                    ${ location.pathname === '/comunidad' ? "activeMode" : ""}
                `}
                to={"/comunidad"}
              >
                {textosInterfaz?.comunidad || 'Comunidad'}
              </Link>
            </li>

            <li>
              <HGResourcesButton />
            </li>
          </>
        }
      </ul>

    </>
  )
}
